<template>
  <div>
    <v-form v-model="valid" @submit.prevent>
      <v-text-field
        v-model="data.name"
        label="Nome"
        outlined
        required
        dense
        :disabled="loading"
        :rules="[(v) => !!v || 'Nome é obrigatório']"
      />
      <v-text-field
        v-model="data.email"
        label="Email"
        outlined
        required
        dense
        :disabled="loading"
        :rules="[(v) => !!v || 'Email é obrigatório']"
      />
      <phone-input
        :phone="data.phone"
        label="Telefone"
        @update:phone="(e) => (data.phone = e)"
        :ddi="data.ddi"
        @update:ddi="(e) => (data.ddi = e)"
        dense
        outlined
        :optional="true"
      />
      <v-text-field-simplemask
        v-model="data.document"
        label="CNPJ"
        class="mb-3"
        v-bind:properties="{
          prefix: '',
          suffix: '',
          readonly: false,
          outlined: true,
          clearable: false,
          placeholder: '99.999.999/9999-99',
          type: 'tel',
          rules: [
            (v) => !!v || 'CNPJ é obrigatório',
            (v) => validateCnpj(v) || 'CNPJ inválido',
          ],
          disabled: loading,
        }"
        v-bind:options="{
          inputMask: '##.###.###/####-##',
          outputMask: '##.###.###/####-##',
          empty: '',
          applyAfter: false,
          alphanumeric: false,
          lowerCase: false,
        }"
      />
      <v-alert v-if="error" type="error" text>
        {{ error }}
      </v-alert>
      <div class="d-flex justify-end">
        <v-btn
          @click="saveCompany"
          :disabled="loading || !valid"
          :loading="loading"
          color="success"
          depressed
        >
          Salvar
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import COMPANY from "@/services/ultimate/company";
import PhoneInput from "@/components/global/PhoneInput.vue";
import validateCnpj from "@/utils/validate-cnpj";

export default {
  name: "CompanyData",
  components: {
    PhoneInput,
  },
  data: () => ({
    valid: false,
    loading: false,
    error: null,
    data: {
      name: "",
      email: "",
      phone: "",
      ddi: 55,
      document: "",
    },
  }),
  methods: {
    validateCnpj,
    loadCompany() {
      this.data = {
        ...this.company,
        ddi: 55,
      };
    },
    async saveCompany() {
      try {
        this.loading = true;
        this.error = null;
        await COMPANY.update(this.company.id, this.data);
        this.$emit("refresh");
      } catch (error) {
        this.error = error.message || "Erro ao salvar empresa";
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    company: {
      handler(newVal) {
        this.loadCompany();
      },
      immediate: true,
    },
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.loadCompany();
  },
};
</script>